import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'
import { UpdateScheduleRequestDTO } from '@core/api/dtos/request/schedule/update'

export const scheduleService = {
	createSchedule(
		data: UpdateScheduleRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/my/schedules', data, config)
	},

	updateSchedule(
		scheduleId: string,
		data: UpdateScheduleRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.put(`/my/schedules/${scheduleId}`, data, config)
	},

	getSchedules(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/schedules', config)
	},

	getAssignedSchedules(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/schedules/assigned', config)
	},

	getInUseSchedules(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/schedules/in-use', config)
	},

	getSchedule(
		scheduleId: string,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.get(`/my/schedules/${scheduleId}`, config)
	},

	getScheduleDetails(scheduleId: string, config?: AxiosRequestConfig) {
		return apiClient.get(`/my/schedules/${scheduleId}`, config)
	},

	deleteSchedule(
		scheduleId: string,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.delete(`/my/schedules/${scheduleId}`, config)
	},

	toggleScheduleFavorite(
		scheduleId: string,
		favorite: boolean,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post(
			`/my/schedules/${scheduleId}/favorites`,
			{ favorite },
			config
		)
	},

	getScheduleGroups(
		scheduleId: string,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.get(`/my/schedules/${scheduleId}/groups`, config)
	},

	getRecommendedSchedules(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('my/schedules/recommended', config)
	},

	getFavoriteSchedules(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/schedules/favorites', config)
	},

	/**
	 * Get zones a schedule is assigned to
	 */
	getScheduleZones(
		scheduleId: string,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.get(`/my/schedules/${scheduleId}/zones`, config)
	},
}

export default scheduleService
